// alerts
export const ALERT_CREATED = 'ALERT_CREATED';

export function AlertCreated(alertObj) {
  return {
    type: ALERT_CREATED,
    alert: alertObj
  }
}


// cart 
export const CART_PRODUCT_ADDED = 'CART_PRODUCT_ADDED';
export const CART_PRODUCT_REMOVED = 'CART_PRODUCT_REMOVED';
export const CART_CLEARED = 'CART_CLEARED';

export function CartProductAdded(product) {
  return {
    type: CART_PRODUCT_ADDED,
    product: product
  }
}

export function CartProductRemoved(product) {
  return {
    type: CART_PRODUCT_REMOVED,
    product: product
  }
}

export function CartCleared() {
  return {
    type: CART_CLEARED
  }
}


export const EVENT_CREATED = 'EVENT_CREATED';
export function EventCreated(eventObj) {
  return {
    type: EVENT_CREATED,
    alert: eventObj
  }
}

// org
export const ORG_LOADED = 'ORG_LOADED';
export const ORG_UPDATED = 'ORG_UPDATED';

export function OrgLoaded(orgObj) {
  return {
    type: ORG_LOADED,
    org: orgObj
  }
}

export function OrgUpdated(orgObj) {
  return {
    type: ORG_UPDATED,
    org: orgObj
  }
}

// lessons
export const LESSON_SELECTED = 'LESSON_SELECTED';
export const LESSONS_LOADED = 'LESSONS_LOADED';

export function LessonSelected(lesson) {
  return {
    type: LESSON_SELECTED,
    lesson: lesson
  }
}

export function LessonsLoaded(lessons) {
  return {
    type: LESSONS_LOADED,
    lessons: lessons
  }
}

// locations
export const LOCATION_CREATED = 'LOCATION_CREATED';
export const LOCATIONS_LOADED = 'LOCATIONS_LOADED';
export const LOCATION_UPDATED = 'LOCATION_UPDATED';

export function LocationCreated(location) {
  return {
    type: LOCATION_CREATED,
    location: location
  }
}

export function LocationsLoaded(locations) {
  return {
    type: LOCATIONS_LOADED,
    locations: locations
  }
}

export function LocationUpdated(location) {
  return {
    type: LOCATION_UPDATED,
    location: location
  }
}

// products 
export const PRODUCT_CREATED = 'PRODUCT_CREATED';
export const PRODUCTS_LOADED = 'PRODUCTS_LOADED';
export const PRODUCT_UPDATED = 'PRODUCT_UPDATED';

export function ProductCreated(product) {
  return {
    type: PRODUCT_CREATED,
    product: product
  }
}

export function ProductsLoaded(products) {
  return {
    type: PRODUCTS_LOADED,
    products: products
  }
}

export function ProductUpdated(product) {
  return {
    type: PRODUCT_UPDATED,
    product: product
  }
}

// user
export const USER_LOGGEDIN = 'USER_LOGGEDIN';
export const USER_LOGGEDOUT = 'USER_LOGGEDOUT';

export function UserLoggedIn(userObj) {
  return {
    type: USER_LOGGEDIN,
    user: userObj
  }
}

export function UserLoggedOut() {
  return {
    type: USER_LOGGEDOUT,
    user: null
  }
}




// WEBPACK FOOTER //
// ./src/redux/actions.js